import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {BehaviorSubject, exhaustMap, map, Observable, take, tap} from "rxjs";
import {LoaderService} from "./loader.service";
import {AuthenticationService} from "./authentication.service";
import {ActionResult, ActionResultList, Organiser} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class OrganiserService {
  private static _organisers: BehaviorSubject<ActionResultList<Organiser[], number> | undefined> = new BehaviorSubject<ActionResultList<Organiser[], number> | undefined>(undefined);
  private static _currentOrganiser: BehaviorSubject<Organiser | undefined> = new BehaviorSubject<Organiser | undefined>(undefined);
  private static _loggedInOrganiser: BehaviorSubject<Organiser | undefined> = new BehaviorSubject<Organiser | undefined>(undefined);

   get organisers(): BehaviorSubject<ActionResultList<Organiser[], number> | undefined> {
    return OrganiserService._organisers;
  }

  get currentOrganiser(): BehaviorSubject<Organiser | undefined> {
    return OrganiserService._currentOrganiser;
  }

  get loggedInOrganiser(): BehaviorSubject<Organiser | undefined> {
    return OrganiserService._loggedInOrganiser;
  }

  constructor(private http: HttpClient, private loaderService: LoaderService, private authService: AuthenticationService, private environmentService:EnvironmentService) {
  }

  setCurrentOrganiser(organiser: Organiser | undefined) {
    this.currentOrganiser.next(organiser);
  }

  getOrganiser(organiserId: number | undefined) {
    this.http.post<ActionResult<Organiser | undefined>>(this.environmentService.getApiUrl() + "/api/organiser/getbyid", organiserId).subscribe((actionResult: ActionResult<Organiser | undefined>) => {
      this.currentOrganiser.next(actionResult.result);
    });
  }

  getLoggedInOrganiser() {
    this.http.get<ActionResult<Organiser | undefined>>(this.environmentService.getApiUrl() + "/api/organiser/details").subscribe((actionResult: ActionResult<Organiser | undefined>) => {
      this.loggedInOrganiser.next(actionResult.result);
    });
  }

  updateOrganiser(organiser: Organiser, onSuccess: () => void, onError: () => void) {
    this.loaderService.startLoading();
    this.authService.jwtResponse.pipe(take(1), exhaustMap(() => {
      return this.http.post<ActionResult<boolean>>
      (this.environmentService.getApiUrl() + (organiser.id ? "/api/organiser/update" : "/api/organiser/add"), organiser);
    })).pipe(tap(() => this.loaderService.dismissLoading())).subscribe((actionResult: ActionResult<boolean>) => {
      if (actionResult.resultCode !== -1) {
        onSuccess();
      } else {
        onError();
      }
      if (organiser.id) {
        this.getOrganiser(organiser.id);
      }
    });
  }

  emptyOrganisers(): void {
    this.organisers.next(undefined);
    this.currentOrganiser.next(undefined);
    this.loggedInOrganiser.next(undefined);
  }


  deleteOrganiser(organiserId: number, edit: boolean, onSuccess: () => void, onError: () => void): void {
    this.authService.jwtResponse.pipe(take(1), exhaustMap(() => {
      return this.http.post<ActionResult<boolean>>
      (this.environmentService.getApiUrl() + "/api/organiser/remove", organiserId);
    })).pipe(tap(() => this.loaderService.dismissLoading())).subscribe((actionResult: ActionResult<boolean>) => {
      if (actionResult.resultCode !== -1) {
        onSuccess();
      } else {
        onError();
      }
    });
  }

  getOrganisers(): Observable<Organiser[]> {
    return this.http.get<ActionResultList<Organiser[], number>>(this.environmentService.getApiUrl() + "/api/organiser/getall").pipe(tap(() => {
    }), map((value: ActionResultList<Organiser[], number>) => {
      if (value && value.result && value.result.length != 0) {
        return value.result;
      } else {
        return [];
      }
    }));
  }
}
